module.exports = {

    init: function ($) {

        // do something here
        $('li.post-category-parent')
        .mouseenter(function(){
            if ($(this).find('ul.children').length !== 0) {
                $(this).find('ul.children').slideDown()
            }
        })
        .mouseleave(function(){
            if ($(this).find('ul.children').length !== 0) {
                $(this).find('ul.children').slideUp()
            }
        })
        $(document).click(function(e) {
             
            if(!$(e.target).hasClass('show-more-categories')){
               return  $('ul.more-categories').slideUp();
            }
            return $('ul.more-categories').slideToggle();
        });
        $(document).ready(function(e) {
            $('.wp-block-quote').append('<img style="top: -10px; position: absolute; margin-left: auto; margin-right: auto; left: 0; right: 0;text-align: center;" src="../../wp-content/themes/thecodework/assets/img/blockquote.svg" alt="blockquote image">');
            $('.wp-block-quote').append('<button name="blockquote-tweet"' +
            'style="display: flex; position: absolute; top: -15%; right: 0; background-color: rgba(70, 101, 155, var(--bg-opacity));"'
        +
            'class="text-white md:mb-4 my-1 p-2 md:p-1"><svg class="w-6 h-6 fill-current" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24"><g data-name="twitter"><path d="M8.08 20A11.07 11.07 0 0 0 19.52 9 8.09 8.09 0 0 0 21 6.16a.44.44 0 0 0-.62-.51 1.88 1.88 0 0 1-2.16-.38 3.89 3.89 0 0 0-5.58-.17A4.13 4.13 0 0 0 11.49 9C8.14 9.2 5.84 7.61 4 5.43a.43.43 0 0 0-.75.24 9.68 9.68 0 0 0 4.6 10.05A6.73 6.73 0 0 1 3.38 18a.45.45 0 0 0-.14.84A11 11 0 0 0 8.08 20"></path></g></svg>Tweet</button>');
            $("button[name='blockquote-tweet']").on('click',function(e){
                window.open("https://twitter.com/intent/tweet?url=" + window.location.href + "&text=" + $(e.target.parentNode).find('p').html());
            });
            const params = new URLSearchParams(location.search);
            var category = (params.get('category')) ? params.get('category') : "";
            if(category == "") {
               return  $("li#category-all").addClass('selected');
            }
            return $("li#" + category.replace(" ","-")).addClass('selected');
           
        });

       
        $('#category')
        .on('change',function() {
            const params = new URLSearchParams(location.search);
            params.set('category', this.value);
            params.delete('search');
            window.location.replace(`${location.pathname}?${params.toString()}`);
        })
        $('.search-box')
        .on('click keypress',function(e) {
            const params = new URLSearchParams(location.search);
            if(e.target.id == 'search' && e.which == 13){
                params.set('search', this.value);
            }
            else if(e.target.id == 'searchImage'){
                params.set('search', $('#search').val());
            }
            else {
                return;
            }
            window.location.replace(`${location.pathname}?${params.toString()}`);
        })

    }
};